"use strict";

// "use strict";

jQuery(document).ready(function ($) {
  if ($('.mb-block_team').length) {
    // Get the team members modal block 
    var modalBlock = document.querySelectorAll('.mb-block_team');
    if ('IntersectionObserver' in window) {
      var handleIntersectionModalBlock = function handleIntersectionModalBlock(entries) {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            console.log('#team-modal', entry);

            //move modal to bottom of document for z-indexing issues
            $("#team-modal").appendTo('body');
            $(document).on("click", "body .team-excerpt.open-modal ", function () {
              $("#team-modal").modal({
                show: true
              });
              $('body').addClass('no-scroll');
              $('body').addClass('team-members-block');
            });
            $("#team-modal").click(function (event) {
              if (event.target.id == "team-modal") {
                $('.modal').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                if ($('body').hasClass('no-scroll')) {
                  $('body').removeClass('no-scroll');
                }
              }
            });
            $('a.team-close[data-dismiss="modal"]').click(function (event) {
              if ($('body').hasClass('no-scroll')) {
                $('body').removeClass('no-scroll');
                $('body').removeClass('team-members-block');
              }
            });
            observer.unobserve(entry.target);
          } else {
            // console.log('entry is NOT Intersecting');
          }
        });
      };
      var observer = new IntersectionObserver(handleIntersectionModalBlock);
      modalBlock.forEach(function (modalBlock) {
        return observer.observe(modalBlock);
      });
    } else {
      console.log('Please use a modern browser');
      // <Fallback Logic Here>
    }
  }
});